<file-upload class="h-30 overflow-scroll file-upload-container" [style.width]="'100%'" [ngClass]="class"
    [control]="uploadControl" [accept]="accepted" [animation]="true">